/* DÄMMER Theme – vanilla JS, no dependencies */
(function () {
  'use strict';
  var T = window.theme || { strings: {}, routes: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}} €';
    function fmt(n, p, t, d) {
      p = p == null ? 2 : p; t = t == null ? ',' : t; d = d == null ? '.' : d;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id, trigger) {
    var d = document.getElementById(id);
    if (!d) return false;
    lastFocus = trigger || document.activeElement;
    d.hidden = false;
    document.body.classList.add('is-locked');
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    var panel = $('.drawer__panel', d);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    return true;
  }
  function closeDrawer(d) {
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { d.hidden = true; }, reduceMotion ? 0 : 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-drawer-open]');
    if (t) { e.preventDefault(); openDrawer(t.getAttribute('data-drawer-open'), t); return; }
    var c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('[data-drawer]')); return; }
    var cart = e.target.closest('[data-cart-open]');
    if (cart && T.cartType === 'drawer' && document.getElementById('cart-drawer')) {
      e.preventDefault(); openDrawer('cart-drawer', cart);
    }
  });
  document.addEventListener('keydown', function (e) {
    var open = $('[data-drawer].is-open');
    if (!open) return;
    if (e.key === 'Escape') { closeDrawer(open); return; }
    if (e.key === 'Tab') {
      var f = $$('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])', $('.drawer__panel', open))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header search ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-search-toggle]');
    if (!b) return;
    var p = document.getElementById(b.getAttribute('aria-controls'));
    if (!p) return;
    var open = p.hidden;
    p.hidden = !open;
    b.setAttribute('aria-expanded', String(open));
    if (open) { var i = $('input[type="search"]', p); if (i) i.focus(); }
  });

  /* ---------- Cart (AJAX + Section Rendering API) ---------- */
  function cartSectionIds() {
    return $$('[data-cart-root]').map(function (r) { return r.getAttribute('data-section-id'); });
  }
  function renderCartSections(sections) {
    if (!sections) return;
    var count = null;
    $$('[data-cart-root]').forEach(function (root) {
      var html = sections[root.getAttribute('data-section-id')];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-root]');
      if (!fresh) return;
      root.innerHTML = fresh.innerHTML;
      root.setAttribute('data-count', fresh.getAttribute('data-count'));
      count = fresh.getAttribute('data-count');
    });
    if (count !== null) updateCount(parseInt(count, 10));
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function refreshCart() {
    var ids = cartSectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(renderCartSections);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || T.cartType !== 'drawer' || !document.getElementById('cart-drawer')) return;
    e.preventDefault();
    var btns = $$('[type="submit"]', form).concat(form.id ? $$('[form="' + form.id + '"]') : []);
    var err = $('[data-form-error]', form);
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    if (err) err.hidden = true;
    var fd = new FormData(form);
    fd.append('sections', cartSectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(T.routes.add + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (err) { err.textContent = data.description || data.message || T.strings.error; err.hidden = false; }
          return;
        }
        renderCartSections(data.sections);
        openDrawer('cart-drawer', e.submitter || btns[0]);
      })
      .catch(function () { if (err) { err.textContent = T.strings.error; err.hidden = false; } })
      .finally(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  });

  var lineTimer;
  function changeLine(root, line, qty) {
    root.classList.add('is-updating');
    fetch(T.routes.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: cartSectionIds(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) renderCartSections(data.sections);
        else refreshCart();
        if (data.item_count !== undefined) updateCount(data.item_count);
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { root.classList.remove('is-updating'); });
  }
  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-cart-root]');
    if (!root) return;
    var step = e.target.closest('[data-line-step]');
    var rem = e.target.closest('[data-line-remove]');
    var li = e.target.closest('[data-line]');
    if (!li || (!step && !rem)) return;
    e.preventDefault();
    var input = $('[data-line-qty]', li);
    var q = rem ? 0 : Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-line-step'), 10));
    input.value = q;
    changeLine(root, parseInt(li.getAttribute('data-line'), 10), q);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-line-qty]')) return;
    var root = e.target.closest('[data-cart-root]');
    var li = e.target.closest('[data-line]');
    clearTimeout(lineTimer);
    lineTimer = setTimeout(function () { changeLine(root, parseInt(li.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0)); }, 300);
  });

  /* ---------- Product ---------- */
  function initProduct(root) {
    var json = $('[data-variants]', root);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var isMain = root.hasAttribute('data-main-product');

    function selected() {
      var opts = [];
      $$('[data-option]', root).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-option'), 10);
        if (el.tagName === 'SELECT') opts[i] = el.value;
        else if (el.checked) opts[i] = el.value;
      });
      return opts;
    }
    function find(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }
    function update() {
      var opts = selected();
      var v = find(opts);
      $$('[data-option-label]', root).forEach(function (l) { var i = l.getAttribute('data-option-label'); if (opts[i]) l.textContent = opts[i]; });
      var addBtns = $$('[data-add]', root);
      if (!v) {
        addBtns.forEach(function (b) { b.disabled = true; var s = $('[data-add-label]', b); if (s) s.textContent = T.strings.unavailable; });
        return;
      }
      if (form) { var id = $('[data-variant-id]', form); if (id) id.value = v.id; }
      $$('[data-price-now]', root).forEach(function (el) { el.textContent = formatMoney(v.price); });
      var sale = v.compare > v.price;
      $$('[data-price]', root).forEach(function (el) { el.classList.toggle('is-sale', sale); });
      $$('[data-price-was]', root).forEach(function (el) { el.hidden = !sale; el.textContent = formatMoney(v.compare); });
      $$('[data-price-badge]', root).forEach(function (el) { el.hidden = !sale; });
      $$('[data-price-unit]', root).forEach(function (el) {
        el.hidden = !v.unit;
        if (v.unit) el.textContent = el.textContent.split(':')[0] + ': ' + v.unit;
      });
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        var s = $('[data-add-label]', b);
        if (s) s.textContent = v.available ? T.strings.add : T.strings.soldOut;
      });
      var stock = $('[data-stock]', root);
      if (stock) {
        var th = parseInt(stock.getAttribute('data-threshold'), 10);
        var txt = $('[data-stock-text]', stock);
        stock.classList.remove('is-low', 'is-out');
        if (!v.available) { txt.textContent = T.strings.soldOut; stock.classList.add('is-out'); }
        else if (v.inv <= th) { txt.textContent = T.strings.stockLow.replace('{count}', v.inv); stock.classList.add('is-low'); }
        else txt.textContent = stock.getAttribute('data-show-ok') === 'true' ? T.strings.stockOk : '';
      }
      if (v.media) {
        var slide = $('[data-media-id="' + v.media + '"]', root);
        var track = $('[data-gallery-track]', root);
        if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (isMain && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option]')) update();
      if (e.target.matches('[data-qty-tier]') && form) {
        var q = form.querySelector('[name="quantity"]');
        if (q) q.value = e.target.value;
      }
    });
    var tier = $('[data-qty-tier]:checked', root);
    if (tier && form) { var q = form.querySelector('[name="quantity"]'); if (q) q.value = tier.value; }
    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-qty-step]');
      if (!s) return;
      var input = $('input[name="quantity"]', s.parentNode);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(s.getAttribute('data-qty-step'), 10));
    });
    // initial sync (e.g. bundle cards preselected)
    if ($$('[data-option]', root).length) update();

    // Sticky add to cart
    var sticky = $('[data-sticky-atc]', root);
    var mainBtn = form ? $('[data-add]', form) : null;
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(mainBtn);
    }
  }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    var track = $('[data-gallery-track]', g);
    var thumbs = $$('[data-thumb]', g);
    if (!track || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = track.children[parseInt(t.getAttribute('data-thumb'), 10)];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      });
    }, { passive: true });
  }

  /* ---------- Delivery estimate ---------- */
  function initDelivery(el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    var max = parseInt(el.getAttribute('data-max'), 10) || min;
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    var now = new Date();
    function addBiz(d, n) {
      var r = new Date(d);
      while (r.getDay() === 0 || r.getDay() === 6) r.setDate(r.getDate() + 1);
      while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
      return r;
    }
    var start = new Date(now);
    if (now.getHours() >= cutoff) start.setDate(start.getDate() + 1);
    var f = new Intl.DateTimeFormat(T.locale || 'de', { weekday: 'short', day: 'numeric', month: 'short' });
    var txt = (el.getAttribute('data-template') || '{from} – {to}')
      .replace('{from}', f.format(addBiz(start, min)))
      .replace('{to}', f.format(addBiz(start, max)));
    $('[data-delivery-text]', el).textContent = txt;
    el.hidden = false;
  }

  /* ---------- Announcement ---------- */
  function initAnnouncement(el) {
    var slides = $$('.announcement__slide', el);
    if (slides.length < 2 || reduceMotion) return;
    var i = 0, ms = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000, paused = false;
    el.addEventListener('mouseenter', function () { paused = true; });
    el.addEventListener('mouseleave', function () { paused = false; });
    el.addEventListener('focusin', function () { paused = true; });
    el.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, ms);
  }

  /* ---------- Before / after ---------- */
  function initBA(el) {
    var r = $('[data-ba-range]', el);
    if (!r) return;
    r.addEventListener('input', function () { el.style.setProperty('--pos', r.value + '%'); });
  }

  /* ---------- Sliders ---------- */
  function initSlider(el) {
    var track = $('[data-slider-track]', el);
    var wrap = el.previousElementSibling;
    var prev = wrap ? $('[data-slider-prev]', wrap) : null;
    var next = wrap ? $('[data-slider-next]', wrap) : null;
    if (!track) return;
    function step(dir) {
      var slide = track.children[0];
      var w = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * .8;
      track.scrollBy({ left: dir * w, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    var raw = el.getAttribute('data-countdown').trim().replace(' ', 'T');
    var end = new Date(raw);
    if (isNaN(end)) { el.hidden = true; return; }
    var parts = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end - new Date());
      if (diff <= 0) {
        var msg = el.getAttribute('data-expired');
        el.innerHTML = msg ? '<p class="countdown__label"></p>' : '';
        if (msg) el.firstChild.textContent = msg; else el.hidden = true;
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      parts.d.textContent = pad(Math.floor(s / 86400));
      parts.h.textContent = pad(Math.floor(s % 86400 / 3600));
      parts.m.textContent = pad(Math.floor(s % 3600 / 60));
      parts.s.textContent = pad(s % 60);
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Copy code ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var code = b.getAttribute('data-copy');
    var status = b.parentNode.querySelector('.code__status');
    function done() { if (status) { status.textContent = T.strings.copied; setTimeout(function () { status.textContent = ''; }, 2500); } }
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
    else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (x) {} t.remove(); done(); }
  });

  /* ---------- Hotspots ---------- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-hotspot]');
    if (!h) return;
    var scope = h.closest('.layers') || document;
    var panel = document.getElementById(h.getAttribute('aria-controls'));
    var open = h.getAttribute('aria-expanded') !== 'true';
    $$('[data-hotspot]', scope).forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    $$('[data-hotspot-panel]', scope).forEach(function (p) { p.classList.remove('is-open'); });
    if (open) {
      h.setAttribute('aria-expanded', 'true');
      if (panel) { panel.classList.add('is-open'); if (window.innerWidth < 990) panel.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' }); }
    }
  });

  /* ---------- Video facade (privacy) ---------- */
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-video-type]');
    if (!f) return;
    var type = f.getAttribute('data-video-type'), id = f.getAttribute('data-video-id');
    var src = type === 'youtube'
      ? 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1'
      : 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1&dnt=1';
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = f.getAttribute('data-video-title') || 'Video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    f.replaceWith(iframe);
  });

  /* ---------- Observers ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && !reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: .4 }) : null;

  /* ---------- Misc ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });
  document.addEventListener('submit', function (e) {
    var c = e.target.getAttribute('data-confirm');
    if (c && !window.confirm(c)) e.preventDefault();
  });

  function init(scope) {
    scope = scope || document;
    $$('[data-product]', scope).forEach(initProduct);
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-delivery]', scope).forEach(initDelivery);
    $$('[data-announcement]', scope).forEach(initAnnouncement);
    $$('[data-ba]', scope).forEach(initBA);
    $$('[data-slider]', scope).forEach(initSlider);
    $$('[data-countdown]', scope).forEach(initCountdown);
    $$('select[data-default]', scope).forEach(function (s) { var d = s.getAttribute('data-default'); if (d) s.value = d; });
    $$('.reveal', scope).forEach(function (el) { if (io && !reduceMotion) io.observe(el); else el.classList.add('is-visible'); });
    $$('.ugc__video', scope).forEach(function (v) { if (vio) vio.observe(v); });
    if (reduceMotion) $$('.hero__video', scope).forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest('[data-slider-track]');
    if (s) s.scrollTo({ left: e.target.offsetLeft - s.offsetLeft, behavior: 'smooth' });
  });
})();
